import { Injectable } from '@angular/core';
import { ConsumeCredencialesService } from '../generico/servicio/consume-credenciales.service';
import { MensajeService } from '../generico/servicio/mensaje.service';
import { SpinnerService } from '../spinner.service';

@Injectable({
  providedIn: 'root'
})
export class AccesosPerfilService {

  id_perfil : number;
  dialoRef : any;

  constructor(
    private cred_serv: ConsumeCredencialesService,
    private msjserv : MensajeService,
    private spin : SpinnerService,
  ) { }

  public async gestionar_acceso(data_form){

    const promesa = this.cred_serv.post('gestionarPerfilMenu', data_form).toPromise();

    await promesa.then(
          (data:any)=>{
            this.spin.spin$.next(false);
            let tipo_mensaje = this.msjserv.TIPO_OK
            if (data.code > 0){
              tipo_mensaje = this.msjserv.TIPO_ERROR
            }

            this.msjserv.ver_mensaje(data.msg, '', tipo_mensaje);

          }
        );
    
  }

  public async gestionar_acceso_accion(data_form){
    const promesa = this.cred_serv.post('adicionaAccionPerfil', data_form).toPromise();

    await promesa.then(
      (data:any)=>{
        this.spin.spin$.next(false);
            let tipo_mensaje = this.msjserv.TIPO_OK
            if (data.code > 0){
              tipo_mensaje = this.msjserv.TIPO_ERROR
            }

            this.msjserv.ver_mensaje(data.msg, '', tipo_mensaje);
      }
    );
  }
}
